import { useForm } from '../../../../../shared/form/useForm';
import { useNewCardSchema } from './useNewCardSchema';
import { INewCardFormData } from '../types/INewCardFormData';
import { CreditCardType } from '../../../../../payment/domain/models';

export function useNewCardForm() {
	const validationSchema = useNewCardSchema();
	const form = useForm<INewCardFormData>({
		mode: 'onSubmit',
		validationSchema,
		defaultValues: {
			creditCardType: CreditCardType.Mastercard,
		},
	});

	return form;
}
